'use client';

import React from "react";
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
// import 'swiper/css';
import styles from './ExploreRelatedProg.module.scss';
import { useModalDispatch } from "@/context/ModalContext";
  import { IModalActions, ModalTypes } from '@/types/modal';
  import { pushToDataLayer } from '@/helpers/gtag';
  import { getGlobalStateValue, updateStateSession } from '@/context/utils';                                                                                                                     
  import popupData from '@/data/popup-data.json'; 
import Link from 'next/link';
import { addStaticSubdomain } from '@/revamp/molecules/ProgramCard/utils';
import Carousel from '@/components/molecules/CustomCarousels/Carousel';

interface Program {
  id: number;
  name: string;
  slug: string;
  duration: string;
  level: string;
  image: string;
  BannerSlider:BannerSlider
  BasicDetails: {
    id?: string;
    Heading?: string;
    enabled?: boolean;
    url_key?: string;
    SpecializationText: string
    PROGRAM_ID: string
    Custom10PgType: string
};
}

interface RelatedProgramsProps {
  programs?: Array<{ attributes: Program }>;
  ctaLabel?: string;
  ctaHref?: string;
  associatedPrograms?: any;
  ProgramId?:any;
  SimilarPrograms?:{
    Title?:string;
    Subtitle?:string
  }
}

function ProgramCard({ program }: { program: Program }) {
  const {BasicDetails,slug,BannerSlider}=program
  const Heading=BasicDetails?.Heading
  const Duration=BannerSlider?.Duration
  const Image=BannerSlider?.Image?.source?.data[0]?.attributes
 
  return (
    <div className={styles.card}>
      <div className={styles.cardImageWrapper}>
        <img
        src={Image?.url}
          alt={Image?.alternativeText}
          style={{ objectFit: 'cover' }}
        />
      </div>
      <div className={styles.cardBody}>
        <div className={styles.cardText}>
          <p className={styles.cardTitle}>{Heading}</p>
          <p className={styles.cardSubTitle}>Learn to build and manage successful products</p>
        </div>
        <div className={styles.tags}>
          <span className={styles.tagBlue}>{Duration?.text}</span>
          
          <span className={styles.tagGreen}>Intermediate</span>
        </div>
        <Link prefetch={false} href={`/${program?.slug}`} className={styles.learnMore}>
          Learn More
          <span className={styles.arrowIcon} aria-hidden="true">›</span>
        </Link>
      </div>
    </div>
  );
}

export default function RelatedPrograms({
  ctaLabel = 'Check Scholarship Eligibility',
  ctaHref = '#',
  programs = [],
  associatedPrograms, ProgramId,
  SimilarPrograms={}
}: RelatedProgramsProps) {

   const modalDispatch = useModalDispatch();
             
    const handleCtaClick = () => {                                                                                                                                                                        
      pushToDataLayer({                       
        event: 'lead_initiate',           
        cta_text: ctaLabel,
        section_name: 'explore_related_programs',                                                                                                                                                         
        page_type: getGlobalStateValue('pageType'),
        page_url: window.location.href,
       program_id: ProgramId                                                                                                                                                                  
      });         
                                                                                                                                                                                                          
      updateStateSession({
        parentSection: 'explore_related_programs',                                                                                                                                                        
        leadStartingCta: ctaLabel,
      });                                     
                                          
      modalDispatch({
        type: IModalActions.OpenModal,                                                                                                                                                                    
        data: {
          modalType: ModalTypes.ConnectModalMba,                                                                                                                                                          
          modalData: {
            associatedPrograms,               
            isLandingPage: true,          
            popup: popupData,
            isJobRole: true ,
            programId: ProgramId                                                                                                                                            
          },
        },                                                                                                                                                                                                
      });         
    };

  return (
    <section className={styles.section}>
      {/* Header */}
      <div className={styles.header}>
        <h2 className={styles.title}>{SimilarPrograms?.Title}</h2>
        <p className={styles.subtitle}>{SimilarPrograms?.Subtitle}</p>
      </div>

      {/* Desktop */}
      <Carousel
        config={{
          autoplay: { delay: 30000},
          spaceBetween: 12,
          slidesPerView: 2,
          pagination: {
            status: false,
            className: `${styles.bulletsContainer} revamp_carousel_pagination`,
          },
          breakpoints: {
            0: {
              slidesPerView: 2,
              spaceBetween: 12,
            },
            520: {
              slidesPerView: 2,
              spaceBetween: 12,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
          },
        }}
        className={`${styles.careersCarouselWrapper} relative`}
        slidesContainerClassName={styles.slidesContainer}
        slideWrapperClassName={styles.slideWrapper}
        isSmoothBehaviour={true}
        id="holistics-career"
      >
        {programs.map((item,ind) => {
          return (
            <ProgramCard key={ind} program={item.attributes} />
          );
        })}
      </Carousel>

      {/* Mweb */}
      <div className={styles.cardsCarousel}>
        <Swiper
          modules={[Autoplay]}
          slidesPerView={1.15}
          spaceBetween={10}
          loop={false}
          autoplay={
            programs.length > 4
              ? { delay: 3000, disableOnInteraction: false }
              : false
          }
          breakpoints={{
            480: { slidesPerView: 1.5 },
            640: { slidesPerView: 2.2 },
          }}
        >
          {programs.map((program,ind) => (
            <SwiperSlide key={ind}>
              <ProgramCard program={program.attributes} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* CTA */}
      <div className={styles.ctaWrapper}>
        <a onClick={handleCtaClick} className={styles.ctaButton}>
          {ctaLabel}
          <span className={styles.ctaIcon} aria-hidden="true">✓</span>
        </a>
      </div>
    </section>
  );
}
